import qrcodeMixin from '@/shared/mixins/qrcode.mixin'
import sessionMixin from '@/shared/mixins/session.mixin'

export default {
  name: 'QrCode',
  mixins: [qrcodeMixin, sessionMixin],
  props: {
    externalId: { type: Number, required: true },
    sourceId: { type: Number, required: true },
    endpoint: { type: String, required: true },
    pollInterval: { type: Number, default: 3000 }
  },
  data() {
    return {
      session: {},
      qrCode: {},
      status: null,
      loading: false,
      error: null,
      pollTimer: null,
      countdownTimer: null,
      now: Date.now(),
    }
  },
  computed: {
    remainingSeconds() {
      if (!this.session?.expiresAt) return null
      const expiresAt = new Date(this.session.expiresAt).getTime()
      const diff = Math.floor((expiresAt - this.now) / 1000)
      return diff > 0 ? diff : 0
    },
    remainingLabel() {
      if (this.remainingSeconds === null) return ''
      const m = Math.floor(this.remainingSeconds / 60)
      const s = this.remainingSeconds % 60
      return `${m}:${s.toString().padStart(2, '0')}`
    },
    isExpiringSoon() {
      return this.remainingSeconds !== null && this.remainingSeconds <= 60
    },
    isExpired() {
      return this.remainingSeconds === 0
    },
  },
  created() {
    this.start()
    this.startCountdown()
  },
  beforeDestroy() {
    this.stopPolling()
    this.stopCountdown()
  },
  methods: {
    async start() {
      this.stopPolling()
      this.loading = true
      this.error = null

      this.$root.$emit('showLoading')
      try {
        const data = await this.getQrCodeData(
          this.endpoint,
          this.externalId,
          this.sourceId
        )
        this.qrCode = data?.data

        this.session.id = this.qrCode.sessionId
        this.status = 'loading'
        this.link = this.qrCode.qrCodeLink
        this.qrCode.qrCodeB64 = `data:image/png;base64,${this.qrCode.qrCodeB64}`

        this.$emit('session-created', this.session)
        this.watchStatus()
      } catch (err) {
        this.error = this.$t('qrcode.error')
        this.$emit('error', err)
      } finally {
        this.loading = false
        this.$root.$emit('hideLoading')
      }
    },

    async checkStatus() {
      if (!this.session || !this.pollTimer)
        return

      try {
        const result = await this.getSessionData()

        if (result) {
          this.status = result.status.toLowerCase()

          if (result.expiresAt) {
            this.session = { ...this.session, expiresAt: result.expiresAt, createdAt: result.createdAt }
          }

          this.$emit('status-change', this.status)
        }
        else
        {
          this.status = 'closed'
        }

        if (['closed', 'expired'].includes((this.status || '').toLowerCase()) || !result) {
          this.stopPolling()
        }
      } catch (err) {
        this.stopPolling()
        if (err.response?.status === 404)
        {
          this.error = this.$t('qrcode.status_error')
        }
        else if (err.response?.status === 401)
        {
          this.status = 'expired'
        }
        else
        {
          this.error = this.$t('qrcode.error')
        }
        this.$emit('error', err)
      }
    },

    watchStatus() {
      this.stopPolling()
      this.pollTimer = setInterval(this.checkStatus, this.pollInterval)
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },

    startCountdown() {
      this.stopCountdown()
      this.countdownTimer = setInterval(() => {
        this.now = Date.now()
      }, 1000)
    },

    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
  },
}
